












































import { Component, Vue, Prop } from 'vue-property-decorator';
import MenuButton from '@/components/buttons/MenuButton.vue';
import MoreButton from '@/components/buttons/MoreButton.vue';

@Component({
  components: {
    MenuButton,
    MoreButton
  }
})
export default class SBKHeader extends Vue {
  private menuOpen:Boolean = false;
}
